import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from '@/lib/i18n'
import { DsuQuotaDetail } from '../../../../-components/dsu-quota-detail'

export const Route = createFileRoute(
	'/(private)/bando/$residenceId/attivita/quota-dsu/'
)({
	// The page names the students who hold a seat and logs the access: only opening it runs the read.
	preload: false,
	component: DsuQuotaPage,
	staticData: {
		breadcrumb: 'admin-dsu-quota:page_title'
	}
})

/** The DSU quota of the residence for its manager (FFD 2.17): reached from the box and the task of the first page. */
function DsuQuotaPage() {
	const { t } = useTranslation()
	const { residenceId } = Route.useParams()
	return (
		<section className='mx-auto flex w-full max-w-5xl flex-col gap-6 p-4 md:p-6'>
			<header className='flex flex-col gap-2'>
				<h1 className='font-semibold text-xl'>
					{t('admin-dsu-quota:page_title')}
				</h1>
				<p className='text-muted-foreground text-sm'>
					{t('admin-dsu-quota:intro')}
				</p>
			</header>
			<DsuQuotaDetail reader='manager' residenceId={residenceId} />
		</section>
	)
}
